<template>
  ``
  <div id="nav">
  
<Header/>

  </div>
  <router-view v-slot="{Component}">
    <transition name="route" mode="out-in">
      <component :is="Component"></component>
    </transition>
  </router-view>


  <!-- <router-view/> -->
</template>
<script>

import  Header from "./components/Partials/Header.vue"

export default {
components:{
  Header
},

methods:{
mounted () {
  window.scrollTo(0, 0)
  
}
}


}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800&family=MuseoModerno&family=Original+Surfer&family=Poppins:wght@200&display=swap');

.route-enter-from{
  opacity: 0;
  transform: translateX(100px);
}
.route-enter-active{
  transition: all .3s ease-out
}
.route-leave-to{
  opacity: 0;
  transform: translateX(-100px);
}
.route-leave-active{
transition: all .3s ease-in
}


#app {
  font-family: 'Montserrat', sans-serif ;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 
  color: #2c3e50;
}

button{
  font-family: 'Montserrat', sans-serif;
}

html{
  scroll-behavior: smooth;
}

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #FFFFF2;
  
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #791E94; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey; 
}
/* html, body{
font-family: 'Montserrat', sans-serif;
} */

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
